// Central content + image assets for the InaTeB website
export const IMAGES = {
  heroStart: "/heroes/start.png?v=1",
  heroLeistungen: "https://static.prod-images.emergentagent.com/jobs/d6404cd0-f809-45ab-b987-87790944bd64/images/bc8c8998623144cd313f675f1bcc152da5859509b2b3298ba6a747265d7f6362.png",
  heroBranchen: "/heroes/branchen.png?v=1",
  heroUeber: "https://static.prod-images.emergentagent.com/jobs/d6404cd0-f809-45ab-b987-87790944bd64/images/7fa7ed073755dc7c84b8e1e978477ab3913077236e1e8dd609790f74232b3f28.png",
  worldMap: "https://static.prod-images.emergentagent.com/jobs/d6404cd0-f809-45ab-b987-87790944bd64/images/05b738fa846d211a727b5fa979b7d85bdcac1ae5eed0924c57dc33e65320c535.png",
  contactEngineers: "/people/kontakt.png?v=6",
  dataDashboard: "/services/fehleranalyse.png?v=1",
  automotive: "/branches/automobil.png?v=1",
  zulieferindustrie: "/branches/zuliefer.png?v=1",
  stahlMetall: "/branches/stahl.png?v=1",
  umwelttechnik: "/branches/umwelt.png?v=1",
  sondermaschinen: "/branches/sondermaschinen.png?v=1",
  serviceWartung: "/people/worker.png?v=6",
  inbetriebnahme: "/services/inbetriebnahme.png?v=1",
  conveyor: "/services/umbauten.png?v=1",
  engineersTablet: "/people/tablet.png?v=6",
  teamCoils: "/people/team.png?v=6",
};

export const COMPANY = {
  name: "InaTeB",
  full: "Industrieanlagenservice & Anlagentechnik",
  legalName: "Inateb Industrieanlagen Technik Börklü UG (haftungsbeschränkt)",
  street: "Mörikestraße 22",
  zip: "83059 Kolbermoor",
  geschaeftsfuehrer: "M. Börklü",
  phone: "+49 8031 2095212",
  email: "info@inateb.com",
  web: "www.inateb.com",
};

// Social-Media-Profile. URLs hier eintragen, sobald die Profile angelegt sind –
// die Buttons erscheinen dann automatisch mit dem korrekten Link.
// Leer lassen ("") -> Button verlinkt vorerst auf "#" (vorbereitet, noch ohne Ziel).
export const SOCIAL = {
  linkedin: "", // z.B. "https://www.linkedin.com/company/inateb"
  facebook: "", // z.B. "https://www.facebook.com/inateb"
};

export const NAV = [
  { label: "Startseite", path: "/" },
  { label: "Leistungen", path: "/leistungen" },
  { label: "Branchen", path: "/branchen" },
  { label: "Über InaTeB", path: "/ueber" },
  { label: "Kontakt", path: "/kontakt" },
];

export const SERVICES = [
  {
    key: "inbetriebnahme",
    icon: "Settings2",
    title: "Inbetriebnahme",
    short: "Inbetriebnahme von Maschinen und Anlagen.",
    long: "Begleitung neuer oder umgebauter Anlagen bis zur erfolgreichen Produktionsfreigabe.",
    image: IMAGES.inbetriebnahme,
    points: ["Maschinen & Produktionsanlagen", "Roboterzellen", "Fördertechnik", "Sondermaschinen", "Produktionsanläufe"],
  },
  {
    key: "umbauten",
    icon: "Wrench",
    title: "Umbauten & Retrofit & Reuse",
    short: "Anpassung, Umbau und Modernisierung bestehender Anlagen.",
    long: "Mechanische und steuerungstechnische Anpassungen sowie Modernisierung bestehender Systeme.",
    image: IMAGES.conveyor,
    points: ["Erweiterungen", "Anpassungen", "Modernisierung", "Komponentenwechsel", "Nachrüstungen"],
  },
  {
    key: "service",
    icon: "ClipboardCheck",
    title: "Service & Wartung",
    short: "Zuverlässige Wartung und Unterstützung für einen störungsfreien Betrieb.",
    long: "Vorbeugende Maßnahmen und Unterstützung bei Störungen zur Sicherstellung der Anlagenverfügbarkeit.",
    image: IMAGES.serviceWartung,
    points: ["Wartungsunterstützung", "Inspektionen", "Anlagenstillstände", "Austauschmaßnahmen", "Unterstützung vor Ort"],
  },
  {
    key: "fehleranalyse",
    icon: "Search",
    title: "Fehleranalyse",
    short: "Schnelle Analyse, gezielte Störungsbeseitigung und nachhaltige Lösungen.",
    long: "Unterstützung bei Störungen, Fehleranalysen und technischen Problemen.",
    image: IMAGES.dataDashboard,
    points: ["Störungssuche", "Ursachenanalyse", "Anlagenprüfung", "Dokumentation", "Lösungsentwicklung"],
  },
  {
    key: "optimierung",
    icon: "TrendingUp",
    title: "Anlagenoptimierung",
    short: "Prozesse verbessern, Effizienz steigern und Ressourcen optimal nutzen.",
    long: "Verbesserung von Prozessen, Taktzeiten und Anlagenverfügbarkeit.",
    image: IMAGES.engineersTablet,
    points: ["Prozessverbesserung", "Verfügbarkeit steigern", "Ressourcenverbrauch senken", "Materialfluss optimieren", "Technische Anpassungen"],
  },
];

export const BRANCHES = [
  {
    icon: "Car",
    title: "Automobilindustrie",
    desc: "Unterstützung entlang des gesamten Produktionsprozesses in modernen Fertigungsanlagen und Robotersystemen.",
    image: IMAGES.automotive,
    points: ["Robotersysteme & Roboterzellen", "Klebstoff- & Dosieranlagen", "Montage- & Handlingsysteme", "Prüf- & Messsysteme", "Produktionsanläufe"],
  },
  {
    icon: "Factory",
    title: "Zulieferindustrie",
    desc: "Technische Unterstützung bei Modernisierungen, Anpassungen und Projekten in laufenden Anlagen.",
    image: IMAGES.zulieferindustrie,
    points: ["Fertigungs- & Bearbeitungsanlagen", "Montage- & Handlingsysteme", "Prüf- & Testanlagen", "Materialfluss-Systeme", "Anlagenanpassungen"],
  },
  {
    icon: "Building2",
    title: "Stahl- & Metallindustrie",
    desc: "Erfahrung in robusten Produktionsumgebungen mit hohen Anforderungen an Verfügbarkeit und Leistung.",
    image: IMAGES.stahlMetall,
    points: ["Bearbeitungs- & Produktionsanlagen", "Förder- & Transportsysteme", "Hydraulik & Antriebstechnik", "Sondermaschinen", "Modernisierungsprojekte"],
  },
  {
    icon: "Recycle",
    title: "Umwelttechnik",
    desc: "Unterstützung bei Anlagen zur Ressourcenverwertung, Aufbereitung und Prozessoptimierung.",
    image: IMAGES.umwelttechnik,
    points: ["Recycling- & Sortieranlagen", "Förder- & Transporttechnik", "Automatisierte Prozesse", "Anlagenumbauten", "Prozessoptimierung"],
  },
  {
    icon: "Cog",
    title: "Sondermaschinenbau",
    desc: "Begleitung von Projekten von der Inbetriebnahme bis zur Optimierung individueller Lösungen.",
    image: IMAGES.sondermaschinen,
    points: ["Sondermaschinen & Anlagen", "Roboter- & Automatisierungslösungen", "Prototypen & Versuchsanlagen", "Kundenabnahmen", "Technische Optimierungen"],
  },
];

export const MORE_BRANCHES = [
  { icon: "Milk", label: "Lebensmittel­industrie" },
  { icon: "FlaskConical", label: "Chemie- & Pharmaindustrie" },
  { icon: "Package", label: "Papier- & Verpackungsindustrie" },
  { icon: "Zap", label: "Energie­technik" },
  { icon: "MoreHorizontal", label: "u. v. m. und viele weitere" },
];

export const PROCESS = [
  { n: "1", title: "Anfrage", desc: "Sie schildern uns Ihr Anliegen – telefonisch, per E-Mail oder über das Kontaktformular." },
  { n: "2", title: "Technische Abstimmung", desc: "Gemeinsame Klärung der Anforderungen, Rahmenbedingungen und technischen Details." },
  { n: "3", title: "Angebot", desc: "Transparentes Angebot mit klarem Leistungsumfang und Zeitrahmen." },
  { n: "4", title: "Durchführung", desc: "Umsetzung vor Ort – flexibel, praxisnah und mit fester Ansprechpartnerschaft." },
  { n: "5", title: "Dokumentation", desc: "Saubere Dokumentation aller Arbeiten und Ergebnisse für Ihre Anlage." },
  { n: "6", title: "Nachbetreuung", desc: "Auch nach Projektabschluss bleiben wir Ansprechpartner für Ihre Anlage." },
];

export const VALUES = [
  { icon: "ShieldCheck", title: "Zuverlässigkeit", desc: "Wir arbeiten engagiert und gewissenhaft daran, unsere Zuverlässigkeit Tag für Tag unter Beweis zu stellen." },
  { icon: "Lightbulb", title: "Lösungsorientierung", desc: "Wir denken mit, hinterfragen und entwickeln Lösungen, die wirklich weiterbringen." },
  { icon: "Cog", title: "Qualität", desc: "Höchste Ansprüche an unsere Arbeit sichern nachhaltige Ergebnisse." },
  { icon: "Users", title: "Respekt", desc: "Fair, ehrlich und auf Augenhöhe – im Team und mit unseren Kunden." },
  { icon: "TrendingUp", title: "Verantwortung", desc: "Wir übernehmen Verantwortung für unsere Arbeit, unsere Kunden und die Zukunft." },
];

export const LOCATIONS = [
  { city: "Kolbermoor", x: 53.3, y: 33.5, home: true },
  { city: "Wolfsburg", x: 53.0, y: 30.5 },
  { city: "Stuttgart", x: 51.6, y: 32.8 },
  { city: "München", x: 53.4, y: 33.6 },
  { city: "Wien", x: 54.9, y: 33.6 },
  { city: "Budapest", x: 56.0, y: 34.2 },
  { city: "Paris", x: 50.2, y: 31.8 },
  { city: "Madrid", x: 47.4, y: 37.5 },
  { city: "Rom", x: 53.2, y: 37.6 },
  { city: "Warschau", x: 56.2, y: 30.6 },
  { city: "Istanbul", x: 58.6, y: 38.2 },
  { city: "São Paulo", x: 34.0, y: 66.5 },
];
